"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountBalance = AccountBalance;
exports.Beneficiary = Beneficiary;
exports.BirthDay = BirthDay;
exports.RateOfReturn = RateOfReturn;
exports.SpouseBirthDay = SpouseBirthDay;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _DropdownForForm = require("../Wizard/DropdownForForm");
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _RequiredMinimumDistributionWizardCalc = require("./RequiredMinimumDistributionWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// TEXT INPUT FIELDS START HERE
function BirthDay(props) {
  var {
    errors,
    touched,
    birthDay,
    birthMonth,
    birthYear,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = props;

  // Set birthdate field based on three separate, dependent fields
  _react.default.useEffect(() => {
    var parsedDate = (0, _parse.default)("".concat(birthMonth, "-").concat(birthDay, "-").concat(birthYear), 'M-d-y', new Date());
    setFieldValue('birthdate', parsedDate);
  }, [birthDay, birthMonth, birthYear, touched.birthdate, setFieldValue]);

  // Set birthdate touched after all three fields have been touched
  _react.default.useEffect(() => {
    setFieldTouched('birthdate', touched.birthMonth && touched.birthDay && touched.birthYear);
  }, [touched.birthDay, touched.birthMonth, touched.birthYear]);

  // Override errors in order sequential order
  _react.default.useEffect(() => {
    var firstBirthdateError = [errors.birthMonth, errors.birthDay, errors.birthYear, errors.birthdate].find(val => !!val);
    setFieldError('birthdate', firstBirthdateError);
  }, [errors.birthDay, errors.birthMonth, errors.birthYear, touched.birthDay, touched.birthMonth, touched.birthYear]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "rmd_birthMonth"
  }, "Birth Month"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "birthMonth",
    id: "rmd_birthMonth",
    placeholder: "MM",
    maxLength: "2",
    value: birthMonth,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RequiredMinimumDistributionWizardCalc.calcName, 'monthOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "rmd_birthDay"
  }, "Birth Day"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "birthDay",
    id: "rmd_birthDay",
    placeholder: "DD",
    maxLength: "2",
    value: birthDay,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RequiredMinimumDistributionWizardCalc.calcName, 'dayOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "rmd_birthYear"
  }, "Birth Year"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "birthYear",
    id: "rmd_birthYear",
    placeholder: "YYYY",
    maxLength: "4",
    value: birthYear,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RequiredMinimumDistributionWizardCalc.calcName, 'yearOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid"
  }, errors.birthdate)));
}
function SpouseBirthDay(props) {
  var {
    errors,
    touched,
    spouseBirthDay,
    spouseBirthMonth,
    spouseBirthYear,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = props;

  // Set spouse birthdate field based on three separate, dependent fields
  _react.default.useEffect(() => {
    var parsedDate = (0, _parse.default)("".concat(spouseBirthMonth, "-").concat(spouseBirthDay, "-").concat(spouseBirthYear), 'M-d-y', new Date());
    if (parsedDate != 'Invalid Date') {
      setFieldValue('spouseBirthdate', parsedDate);
    } else {
      setFieldValue('spouseBirthdate', undefined);
    }
  }, [spouseBirthDay, spouseBirthMonth, spouseBirthYear, touched.spouseBirthdate, setFieldValue]);

  // Set spouse birthdate touched after all three fields have been touched
  _react.default.useEffect(() => {
    setFieldTouched('spouseBirthdate', touched.spouseBirthMonth && touched.spouseBirthDay && touched.spouseBirthYear);
  }, [touched.spouseBirthDay, touched.spouseBirthMonth, touched.spouseBirthYear]);

  // Override errors in order sequential order
  _react.default.useEffect(() => {
    var firstSpouseBirthdateError = [errors.spouseBirthMonth, errors.spouseBirthDay, errors.spouseBirthYear, errors.spouseBirthdate].find(val => !!val);
    setFieldError('spouseBirthdate', firstSpouseBirthdateError);
  }, [errors.spouseBirthDay, errors.spouseBirthMonth, errors.spouseBirthYear, touched.spouseBirthDay, touched.spouseBirthMonth, touched.spouseBirthYear]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "rmd_spouseBirthMonth"
  }, "Birth Month", ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'spouseBirthdate',
    text: _RequiredMinimumDistributionWizardCalc.popoverConfig.spouseBirthdayInfo
  }), ' '), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.spouseBirthdate && touched.spouseBirthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "spouseBirthMonth",
    id: "rmd_spouseBirthMonth",
    placeholder: "MM",
    maxLength: "2",
    value: spouseBirthMonth,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RequiredMinimumDistributionWizardCalc.calcName, 'monthOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "rmd_spouseBirthDay"
  }, "Birth Day"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.spouseBirthdate && touched.spouseBirthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "spouseBirthDay",
    id: "rmd_spouseBirthDay",
    placeholder: "DD",
    maxLength: "2",
    value: spouseBirthDay,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RequiredMinimumDistributionWizardCalc.calcName, 'dayOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "rmd_spouseBirthYear"
  }, "Birth Year"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.spouseBirthdate && touched.spouseBirthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    name: "spouseBirthYear",
    id: "rmd_spouseBirthYear",
    placeholder: "YYYY",
    maxLength: "4",
    value: spouseBirthYear,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RequiredMinimumDistributionWizardCalc.calcName, 'yearOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid"
  }, errors.spouseBirthdate)));
}
function AccountBalance(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'accountBalance';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RequiredMinimumDistributionWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Balance as of December 31 Last Year",
    id: _RequiredMinimumDistributionWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _RequiredMinimumDistributionWizardCalc.popoverConfig.retirementAccountBalanceInfo
  });
}

// DROPDOWNS START HERE
function Beneficiary(props) {
  var {
    values,
    setFieldValue
  } = props;
  var fieldName = 'beneficiary';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: fieldName,
    id: _RequiredMinimumDistributionWizardCalc.idPrefix + fieldName,
    setFieldValue: setFieldValue,
    values: values,
    label: "Relation to Beneficiary",
    placeholderText: "Select One",
    dataArray: _RequiredMinimumDistributionWizardCalc.dropdownOptions.beneficiaryArray,
    calcName: _RequiredMinimumDistributionWizardCalc.calcName
  }));
}
function RateOfReturn(props) {
  var {
    values,
    setFieldValue
  } = props;
  var fieldName = 'rateOfReturn';
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: fieldName,
    id: _RequiredMinimumDistributionWizardCalc.idPrefix + fieldName,
    setFieldValue: setFieldValue,
    values: values,
    label: "Estimated Rate of Return",
    placeholderText: "Select One",
    dataArray: _RequiredMinimumDistributionWizardCalc.dropdownOptions.returnRateArray,
    calcName: _RequiredMinimumDistributionWizardCalc.calcName
  });
}